module.exports = __webpack_public_path__ + "static/img/b51.56745d5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/b51.jpg
// module id = Y3dY
// module chunks = 0